'use client';

import { PickleballCentralLogo } from '@/modules/players/v3/components/images/pickleball-central-logo';
import { CardTitle } from '@/modules/players/v3/components/shared/card/card';
import { DashboardWidgetCard } from '@/modules/players/v3/components/shared/dashboard-widget-card/dashboard-widget-card';
import { GearCardSkeleton } from '@/modules/players/v3/components/shared/gear-card/gear-card-skeleton';

const GEAR_SKELETON_KEYS = Array.from({ length: 4 }, () => crypto.randomUUID());

export const PublicMyGearPlaceholder = () => {
  return (
    <DashboardWidgetCard
      header={
        <>
          <CardTitle>My gear</CardTitle>
          <div className='flex items-center gap-2'>
            <span className='whitespace-nowrap text-sm text-gray-600'>sponsored by</span>
            <PickleballCentralLogo clickable={false} />
          </div>
        </>
      }
    >
      <div className='flex min-h-[220px] items-center gap-3 overflow-hidden'>
        {GEAR_SKELETON_KEYS.map((id) => (
          <GearCardSkeleton key={id} />
        ))}
      </div>
    </DashboardWidgetCard>
  );
};
